module.exports = __webpack_public_path__ + "img/icon_social.b5f54493.svg";